import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useHistory } from "react-router-dom";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from '../../../utilities/TableUtil';
import { normalColumn, dateColumn, actionEditColumn, statusColumn } from '../../../components/DataTable/DataTable.js';
import * as bodyStyle from '../../../components/DataTable/ConsBodyStyle.js';


export default function P411ListA({ dataTable, setDialog  }) {

    const history = useHistory();
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    // const [globalFilter, setGlobalFilter] = useState(null);
    const actionBodyEdit = (data) => {
        history.push({
            pathname: '412',
            state: { contractNo: data.contractNo },
        });
    };
    
    const headerLabel =<span className="hidden-responsive">เพิ่มรายการใหม่</span>;
    const header = (
        <div className="table-header">
            <Button 
                className="p-button p-button-success btn-hidden-responsive" 
                label={headerLabel}
                icon="pi pi-plus" 
                onClick={() => history.push('/412')} 
                autoFocus 
            />
            {/* <span className="p-input-icon-left span-responsive" >
                <i className="pi pi-search" />
                <InputText type="search" placeholder="คำค้น" 
                className="btn-responsive"
                onInput={(e) => setGlobalFilter(e.target.value)}
                />
            </span> */}
        </div>
    );
    
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows} 
                    onPage={(e)=>onPageChange(e,setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >

                    <Column sortable field="requestSeq" header="ลำดับที่" body={(e) => normalColumn(e, 'requestSeq', 'ลำดับที่')} style={{textAlign: 'center',width: '6%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="requestNo" header="เลขที่ใบแจ้งฯ" body={(e) => normalColumn(e, 'requestNo', 'เลขที่สัญญา')} style={{textAlign: 'center',width: '10%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="inspectDate" header="วันที่ตรวจ" body={(e) => normalColumn(e, 'inspectDate', 'วันที่ตรวจ')} style={{textAlign: 'center',width: '8%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column sortable field="inspectTime" header="เวลาที่ตรวจ" body={(e) => normalColumn(e, 'inspectTime', 'เวลาที่ตรวจ')} style={{textAlign: 'center',width: '8%' }} bodyStyle={bodyStyle.TXT_CENTER_OVER} />
                    <Column field="inspectWorkerResult" header="ความเห็นผู้ปฏิบัติงาน" body={(e) => normalColumn(e, 'inspectWorkerResult', 'ความเห็นผู้ปฏิบัติงาน')} style={{ textAlign: 'center'}}  bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="inspectEquipmentResult" header="ความเห็นเครื่องจักร/เครื่องมือ"  body={(e) => normalColumn(e, 'inspectEquipmentResult', 'ความเห็นเครื่องจักร/เครื่องมือ')} style={{ textAlign: 'center',width: '15%' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="coinspectName" header="ผู้ร่วมปฏิบัติงาน"  body={(e) => normalColumn(e, 'coinspectName', 'ผู้ร่วมปฏิบัติงาน')} style={{ textAlign: 'center', width: '15%' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="orderDetail" header="การสั่งการเฉพาะอย่าง"  body={(e) => normalColumn(e, 'orderDetail', 'การสั่งการเฉพาะอย่าง')} style={{ textAlign: 'center', width: '10%' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="programId" header="โปรแกรมที่บันทึก"  body={(e) => normalColumn(e, 'programId', 'โปรแกรมที่บันทึก')} style={{ textAlign: 'center', width: '8%' }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                  
                </DataTable>
            </div>
        </div>
    )
}
